import { render, staticRenderFns } from "./PersonalDataFinancialSponsorForm.vue?vue&type=template&id=dd55cc6a&scoped=true&"
import script from "./PersonalDataFinancialSponsorForm.vue?vue&type=script&lang=ts&"
export * from "./PersonalDataFinancialSponsorForm.vue?vue&type=script&lang=ts&"
import style0 from "./PersonalDataFinancialSponsorForm.vue?vue&type=style&index=0&id=dd55cc6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd55cc6a",
  null
  
)

export default component.exports